import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

//import useUtilities from '../../../hooks/useUtilities';
import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';

function AllInterruptions() {
    const [allInterruption,setAllInterruption]= useState(true);
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    return (
        <>
            <div className='frame5Profile'> {i18n.t('Demandes à valider')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Interruptions de missions')}</span> </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>{i18n.t('Demandes d\'interruptions')}</h4>
                <div className='frame7TableMissionBDCAdmin'>
                    <div className='frame8TableMissionBDCAdmin'>
                        <Button
                            className='frame29CvTheque'
                            onClick={() =>
                            {
                                navigate('/admin/InterruptionsMissions');
                                setAllInterruption(true);
                            }}
                            style={
                                allInterruption == true  ?
                                    {...buttonStyles(),...{
                                        background: '#E7EAF9',
                                        color: '#214DCE',
                                        borderRadius:'40px',
                                    }}:
                                    {...buttonStyles(),...{
                                        color: '#475063',
                                        borderRadius:'40px',
                                    }}
                            }
                        >
                            {i18n.t('En cours')}
                        </Button>

                        <Button
                            className='frame31CvTheque'
                            onClick={() =>
                            {
                                navigate('/admin/InterruptionsMissions/Traitees');
                                setAllInterruption(false);
                            }}
                            //style={
                            //    allInterruption == false  ?
                            //        selectedFrameCvTheque:
                            //        notSelectedFrameCvTheque
                            //}
                            style={
                                allInterruption == false  ?
                                    {...buttonStyles(),...{
                                        background: '#E7EAF9',
                                        color: '#214DCE',
                                        borderRadius:'40px',
                                    }}:
                                    {...buttonStyles(),...{
                                        color: '#475063',
                                        borderRadius:'40px',
                                    }}
                            }
                        >
                            {i18n.t('Traitées')}
                        </Button>
                    </div>
                </div>

                <Outlet/>
            </div>
        </>
    );
}

export default AllInterruptions;
